import useText from '@ab-core/localization/src/useText';
import { getTestIdProp } from '@ab-core/testing';
import Text from '@ab-core/text';
import type { WithUseTextKey } from '@ab-core/utils/types';
import type { FC } from 'react';
import React from 'react';

type InfoTextType = WithUseTextKey & { color?: string };

export const InfoText: FC<InfoTextType> = (props) => {
    const { color, useTextKey } = props;
    const deliveryTimeInfoText = useText(useTextKey);

    return (
        <Text
            color={color ? color : 'black'}
            {...getTestIdProp('product-card-delivery-time-info')}
            className="text-word-break"
        >
            {deliveryTimeInfoText}
        </Text>
    );
};

enum DELIVERY_INFORMATION_TEXT {
    CHANNEL410 = 'CHANNEL410',
    ABAC = 'ABAC',
    PROCUREDPRODUCT = 'PROCUREDPRODUCT',
    DELIVERYFROMFACTORY = 'DELIVERYFROMFACTORY',
    CHARGE = 'CHARGE',
    CHARGELATE = 'CHARGELATE'
}

type DeliveryTimeInfoProps = React.ComponentPropsWithoutRef<'div'> & {
    identifier?: string;
    mainChannelAvailability?: number;
    phillipsburgChannelAvailability?: number;
    quantity?: number;
    customDeliveryInfo?: string;
    procuredProduct?: boolean;
    deliveryFromFactory?: boolean;
};

export const DeliveryTimeInfo: FC<DeliveryTimeInfoProps> = (props) => {
    const {
        identifier,
        className,
        mainChannelAvailability,
        phillipsburgChannelAvailability,
        quantity,
        customDeliveryInfo,
        procuredProduct,
        deliveryFromFactory,
        ...rest
    } = props;

    const isValidIdentifier = Object.values(DELIVERY_INFORMATION_TEXT).includes(
        identifier as DELIVERY_INFORMATION_TEXT
    );

    const showText = () => {
        if (
            (identifier === DELIVERY_INFORMATION_TEXT.CHARGE || identifier === DELIVERY_INFORMATION_TEXT.CHARGELATE) &&
            (procuredProduct || deliveryFromFactory || !mainChannelAvailability)
        ) {
            return false;
        }

        if (
            identifier === DELIVERY_INFORMATION_TEXT.CHANNEL410 &&
            (!quantity ||
                !phillipsburgChannelAvailability ||
                phillipsburgChannelAvailability <= 0 ||
                (mainChannelAvailability && quantity <= mainChannelAvailability))
        ) {
            return false;
        }

        return true;
    };

    let newClassName = 'flex-justify-content-space-between ';

    if (className) {
        newClassName += className;
    }

    return (
        <div className={newClassName} {...rest}>
            {customDeliveryInfo === undefined ? (
                <>
                    {isValidIdentifier && showText() && (
                        <InfoText useTextKey={`productInfos.${identifier?.toLowerCase()}`} />
                    )}
                </>
            ) : (
                customDeliveryInfo
            )}
        </div>
    );
};
